var exports = {
  "k": "x61f99309--845126--container",
};

module.exports = exports;
